<template>
	<v-row>
		<v-col cols="12">
			<v-container>
				<v-row justify="space-between" align="center">
					<v-col md="9" cols="12">
						<navbar :light="false" :showNav="false" />
					</v-col>
					<v-col md="3" cols="12">
						<div class="d-flex justify-center">
							<v-btn
								depressed
								color="secondary"
								@click="$router.push({ name: 'dashboard.index' })"
								>GO TO DASHBOARD</v-btn
							>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-col>
		<v-col cols="12">
			<v-container class="overflow-x-hidden">
				<div class="d-flex justify-space-between align-baseline">
					<div class="text-h4 font-weight-bold primary--text mt-10">
						Investments
					</div>
				</div>
				<v-row class="mt-10">
					<v-col>
						<investment-offers isOnboarding />
					</v-col>
				</v-row>
			</v-container>
		</v-col>
	</v-row>
</template>

<script>
	import Navbar from "@/components/Navbar.vue";
	import InvestmentOffers from "@/views/investments/Offers.vue";

	export default {
		components: {
			Navbar,
			InvestmentOffers,
		},
		data: () => ({
			loading: false,
			selection: 1,
			drawer: null,
			items: [
				{ title: "Home", icon: "mdi-view-dashboard" },
				{ title: "About", icon: "mdi-forum" },
			],
			selectPaymentMethodDialog: null,
			paymentOptions: [
				{
					name: "Pay with Paystack",
					description: "For card and bank transfers",
					icon: "paystack-icon",
				},
				{
					name: "Pay with Wallet",
					description: "Directly from your wallet",
					icon: "wallet-icon",
				},
			],
			numberOfUnits: 1,
			reference: "",
		}),

		methods: {
			invest() {
				this.drawer = false;
				this.selectPaymentMethodDialog = true;
			},
			paystackCallback() {},
			paystackClose() {},
			openPaystack() {
				const btn = document.querySelector(".payButton");
				btn.click();
			},
			initiatePayment() {
				this.selectPaymentMethodDialog = null;
				this.openPaystack();

				this.$nextTick(() => {});
			},
		},
	};
</script>
